import ListingsList from './ListingsList';

export default ListingsList;
